import { create } from "apisauce";

const apiClient = create({
  baseURL: "https://6860ezyr5j.execute-api.us-west-2.amazonaws.com/api/",
});

export default apiClient;
